// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
@charset "UTF-8";
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

:host([hidden]) {
  display: none; }

:host {
  display: block;
  font-family: var(--font-family, var(--default-font-family));
  vertical-align: top; }

:host .root {
  display: block;
  color: var(--color, #201f1e); }

:host svg,
mgt-person svg {
  width: var(--avatar-size-s, var(--avatar-size, 24px));
  height: var(--avatar-size-s, var(--avatar-size, 24px)); }

:host .person-root,
mgt-person .person-root {
  position: relative;
  display: flex;
  align-items: center; }
  :host .person-root .user-avatar,
  mgt-person .person-root .user-avatar {
    width: var(--avatar-size, var(--avatar-size-s, 48px));
    height: var(--avatar-size, var(--avatar-size-s, 48px));
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0; }
    :host .person-root .user-avatar .user-presence,
    mgt-person .person-root .user-avatar .user-presence {
      margin: 0;
      position: absolute;
      left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.72 - 4px);
      top: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.72 - 4px);
      width: calc(vvar(--avatar-size, var(--avatar-size-s, 48px)) * 0.28);
      height: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.28);
      border: 2px solid var(--presence-background-color, #ffffff);
      border-radius: 50%; }
      :host .person-root .user-avatar .user-presence .presence-oof-offline-wrapper,
      mgt-person .person-root .user-avatar .user-presence .presence-oof-offline-wrapper {
        background-color: var(--presence-background-color, #ffffff);
        border-color: #b4009e; }
        :host .person-root .user-avatar .user-presence .presence-oof-offline-wrapper .presence-oof-offline svg,
        mgt-person .person-root .user-avatar .user-presence .presence-oof-offline-wrapper .presence-oof-offline svg {
          color: #b4009e;
          width: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.14);
          margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-basic,
      mgt-person .person-root .user-avatar .user-presence .presence-basic {
        width: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.28 - 4px);
        height: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.28 - 4px);
        border-style: solid;
        border-width: 2px;
        border-radius: 50%;
        margin: 0;
        font-size: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.14);
        vertical-align: top;
        display: flex;
        align-items: center; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-offline,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-offline {
          background-color: var(--presence-background-color, #ffffff);
          border-color: #8a8886; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-available,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-available {
          background-color: #6bb700;
          border-color: #6bb700; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-oof-available,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-oof-available {
          background-color: var(--presence-background-color, #ffffff);
          border-color: #6bb700; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-away,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-away {
          background-color: #ffaa44;
          border-color: #ffaa44; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-dnd,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-dnd {
          background-color: #c50f1f;
          border-color: #c50f1f; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-oof-dnd,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-oof-dnd {
          background-color: var(--presence-background-color, #ffffff);
          border-color: #c50f1f; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-busy,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-busy {
          background-color: #c50f1f;
          border-color: #c50f1f; }
        :host .person-root .user-avatar .user-presence .presence-basic.presence-oof-busy,
        mgt-person .person-root .user-avatar .user-presence .presence-basic.presence-oof-busy {
          background-color: var(--presence-background-color, #ffffff);
          border-color: #c50f1f; }
      :host .person-root .user-avatar .user-presence .presence-offline::before,
      mgt-person .person-root .user-avatar .user-presence .presence-offline::before {
        content: "";
        color: #8a8886;
        font-weight: bold;
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-available::before,
      mgt-person .person-root .user-avatar .user-presence .presence-available::before {
        content: "";
        color: var(--presence-background-color, #ffffff);
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-oof-available::before,
      mgt-person .person-root .user-avatar .user-presence .presence-oof-available::before {
        content: "";
        color: #6bb700;
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-away::before,
      mgt-person .person-root .user-avatar .user-presence .presence-away::before {
        content: "";
        color: var(--presence-background-color, #ffffff);
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-dnd::before,
      mgt-person .person-root .user-avatar .user-presence .presence-dnd::before {
        content: "";
        color: var(--presence-background-color, #ffffff);
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
      :host .person-root .user-avatar .user-presence .presence-oof-dnd::before,
      mgt-person .person-root .user-avatar .user-presence .presence-oof-dnd::before {
        content: "";
        color: #c50f1f;
        margin-left: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.07 - 2px); }
    :host .person-root .user-avatar.initials,
    mgt-person .person-root .user-avatar.initials {
      color: var(--initials-color, white);
      border-radius: var(--avatar-border-radius, 50%);
      font-weight: 400; }
      :host .person-root .user-avatar.initials .initials-text,
      :host .person-root .user-avatar.initials .contact-icon,
      mgt-person .person-root .user-avatar.initials .initials-text,
      mgt-person .person-root .user-avatar.initials .contact-icon {
        cursor: default;
        margin-top: -1px;
        font-size: calc(var(--avatar-size, var(--avatar-size-s, 48px)) * 0.4); }
      :host .person-root .user-avatar.initials .contact-icon,
      mgt-person .person-root .user-avatar.initials .contact-icon {
        display: inline; }
    :host .person-root .user-avatar.small,
    mgt-person .person-root .user-avatar.small {
      width: var(--avatar-size-s, var(--avatar-size, 24px));
      height: var(--avatar-size-s, var(--avatar-size, 24px)); }
      :host .person-root .user-avatar.small .initials-text,
      :host .person-root .user-avatar.small .contact-icon,
      mgt-person .person-root .user-avatar.small .initials-text,
      mgt-person .person-root .user-avatar.small .contact-icon {
        font-size: calc(var(--avatar-size-s, var(--avatar-size, 24px)) * 0.4); }
      :host .person-root .user-avatar.small .user-presence,
      mgt-person .person-root .user-avatar.small .user-presence {
        left: calc(var(--avatar-size-s, var(--avatar-size, 24px)) - 8px);
        top: calc(var(--avatar-size-s, var(--avatar-size, 24px)) - 8px);
        width: 8px;
        height: 8px; }
        :host .person-root .user-avatar.small .user-presence .presence-basic,
        mgt-person .person-root .user-avatar.small .user-presence .presence-basic {
          width: 4px;
          height: 4px;
          border-radius: 4px;
          padding: 0; }
          :host .person-root .user-avatar.small .user-presence .presence-basic .presence-oof-offline svg,
          mgt-person .person-root .user-avatar.small .user-presence .presence-basic .presence-oof-offline svg {
            height: 0;
            width: 0; }
        :host .person-root .user-avatar.small .user-presence .presence-offline::before,
        :host .person-root .user-avatar.small .user-presence .presence-available::before,
        :host .person-root .user-avatar.small .user-presence .presence-oof-available::before,
        :host .person-root .user-avatar.small .user-presence .presence-away::before,
        :host .person-root .user-avatar.small .user-presence .presence-oof-away::before,
        :host .person-root .user-avatar.small .user-presence .presence-dnd::before,
        :host .person-root .user-avatar.small .user-presence .presence-oof-dnd::before,
        :host .person-root .user-avatar.small .user-presence .presence-oof-offline::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-offline::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-available::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-oof-available::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-away::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-oof-away::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-dnd::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-oof-dnd::before,
        mgt-person .person-root .user-avatar.small .user-presence .presence-oof-offline::before {
          content: ''; }
    :host .person-root .user-avatar .img-wrapper,
    mgt-person .person-root .user-avatar .img-wrapper {
      height: 100%;
      width: 100%;
      display: flex;
      overflow: hidden;
      border: var(--avatar-border, 0);
      border-radius: var(--avatar-border-radius, 50%);
      position: relative; }
      :host .person-root .user-avatar .img-wrapper img,
      mgt-person .person-root .user-avatar .img-wrapper img {
        position: absolute;
        display: block;
        top: -100%;
        right: -100%;
        bottom: -100%;
        left: -100%;
        margin: auto;
        height: 100%;
        width: auto; }
    :host .person-root .user-avatar.pinkRed10,
    mgt-person .person-root .user-avatar.pinkRed10 {
      background-color: var(--initials-background-color, #750b1c); }
    :host .person-root .user-avatar.red20,
    mgt-person .person-root .user-avatar.red20 {
      background-color: var(--initials-background-color, #a4262c); }
    :host .person-root .user-avatar.red10,
    mgt-person .person-root .user-avatar.red10 {
      background-color: var(--initials-background-color, #d13438); }
    :host .person-root .user-avatar.orange20,
    mgt-person .person-root .user-avatar.orange20 {
      background-color: var(--initials-background-color, #ca5010); }
    :host .person-root .user-avatar.orangeYellow20,
    mgt-person .person-root .user-avatar.orangeYellow20 {
      background-color: var(--initials-background-color, #986f0b); }
    :host .person-root .user-avatar.green10,
    mgt-person .person-root .user-avatar.green10 {
      background-color: var(--initials-background-color, #498205); }
    :host .person-root .user-avatar.green20,
    mgt-person .person-root .user-avatar.green20 {
      background-color: var(--initials-background-color, #0b6a0b); }
    :host .person-root .user-avatar.cyan20,
    mgt-person .person-root .user-avatar.cyan20 {
      background-color: var(--initials-background-color, #038387); }
    :host .person-root .user-avatar.cyan30,
    mgt-person .person-root .user-avatar.cyan30 {
      background-color: var(--initials-background-color, #005b70); }
    :host .person-root .user-avatar.cyanBlue10,
    mgt-person .person-root .user-avatar.cyanBlue10 {
      background-color: var(--initials-background-color, #0078d4); }
    :host .person-root .user-avatar.cyanBlue20,
    mgt-person .person-root .user-avatar.cyanBlue20 {
      background-color: var(--initials-background-color, #004e8c); }
    :host .person-root .user-avatar.blue10,
    mgt-person .person-root .user-avatar.blue10 {
      background-color: var(--initials-background-color, #4f6bed); }
    :host .person-root .user-avatar.blueMagenta30,
    mgt-person .person-root .user-avatar.blueMagenta30 {
      background-color: var(--initials-background-color, #5c2e91); }
    :host .person-root .user-avatar.blueMagenta20,
    mgt-person .person-root .user-avatar.blueMagenta20 {
      background-color: var(--initials-background-color, #8764b8); }
    :host .person-root .user-avatar.magenta20,
    mgt-person .person-root .user-avatar.magenta20 {
      background-color: var(--initials-background-color, #881798); }
    :host .person-root .user-avatar.magenta10,
    mgt-person .person-root .user-avatar.magenta10 {
      background-color: var(--initials-background-color, #c239b3); }
    :host .person-root .user-avatar.magentaPink10,
    mgt-person .person-root .user-avatar.magentaPink10 {
      background-color: var(--initials-background-color, #e3008c); }
    :host .person-root .user-avatar.orange30,
    mgt-person .person-root .user-avatar.orange30 {
      background-color: var(--initials-background-color, #8e562e); }
    :host .person-root .user-avatar.gray30,
    mgt-person .person-root .user-avatar.gray30 {
      background-color: var(--initials-background-color, #7a7574); }
    :host .person-root .user-avatar.gray20,
    mgt-person .person-root .user-avatar.gray20 {
      background-color: var(--initials-background-color, #69797e); }
  :host .person-root .details,
  mgt-person .person-root .details {
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    line-height: 1.4;
    margin-left: var(--details-spacing, 12px); }
    :host .person-root .details.small,
    mgt-person .person-root .details.small {
      margin-left: var(--details-spacing, 6px); }
    :host .person-root .details > div,
    mgt-person .person-root .details > div {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden; }
    :host .person-root .details .line1,
    mgt-person .person-root .details .line1 {
      font-size: var(--font-size, 14px);
      font-weight: var(--font-weight, 600);
      text-transform: var(text-transform, none); }
    :host .person-root .details .line2,
    mgt-person .person-root .details .line2 {
      color: var(--line2-color, var(--email-color, var(--color, #201f1e)));
      font-size: var(--line2-font-size, var(--email-font-size, 12px));
      font-weight: var(--line2-font-weight, 400);
      text-transform: var(--line2-text-transform, var(text-transform, none)); }

:host .avatar-icon,
mgt-person .avatar-icon {
  display: block;
  line-height: 1;
  margin: 0;
  font-size: var(--avatar-size, var(--avatar-size-s, 48px));
  width: var(--avatar-size, var(--avatar-size-s, 48px));
  height: var(--avatar-size, var(--avatar-size-s, 48px)); }
  :host .avatar-icon.small,
  mgt-person .avatar-icon.small {
    font-size: var(--avatar-size-s, var(--avatar-size, 24px));
    width: var(--avatar-size-s, var(--avatar-size, 24px));
    height: var(--avatar-size-s, var(--avatar-size, 24px)); }

`
];
//# sourceMappingURL=mgt-person-css.js.map